// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1LAYM","bigColWidth":"Table_bigColWidth__1LZJL","biggerColWidth":"Table_biggerColWidth__1n-0c","row":"Table_row__R6MIP","col":"Table_col__2JKQH"};